<template>
	<div class="progress-bar" style="width: 100%;">
		<div class="container" style="width: 100%;">
			<div class="procress-container">
				{{options.percent}}
				<div :style="{'width': options.percent}">
					<span>{{options.percent}}</span>
				</div>
			</div>
			<p style="text-align:center;">{{options.percentInfo}}</p>
		</div>
	</div>
</template>

<script>
export default {
	props: ['options'],
	data() {
		return {

		}
	}
}

</script>

<style scoped lang="scss">
	.container {
		position: relative;
		margin-top: 70px;

		.procress-container {
			width: 600px;
			height: 50px;
			border: 1px solid #ccc;
			border-radius: 5px;
			margin-bottom: 25px;
			line-height: 50px;
			text-align: center;
			color: #0686d8;
			font-size: 22px;

			div {
				position: absolute;
				left: 0;
				border-radius: 5px;
				top: 0;
				height: 50px;
				line-height: 50px;
				width: 300px;
				background: #0686d8;
				overflow: hidden;
				text-align: left;
				color: #fff;

				span {
					color: #fff;
					margin-left: 277px;
				}
			}
		}

		p {
			text-align: center;
			margin-top: 25px;
			margin-bottom: 122px;
			font-size: 14px;
			display: block;
		}
	}

</style>
